export var identity = function identity(x) {
  return x;
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/identity.js
// module id = /Hk3
// module chunks = 86